<template>
  <div class="pop_sales popup_wrap" :class="{'is_checkout_promo':is_checkout_promo}" style="display:block">
    <div class="popup_in">
      <div class="popup" :style="products.length == 2 ? 'max-width:600px': products.length == 1 ? 'max-width:350px;': ''">
        <div class="popup_close stay_close close-animate">
          <a href="javascript:void(0);" @click="closePop()">
            <close />
          </a>
        </div>
        <div class="pp_prod_bottom">
          <h2
            class="title25"
            v-if="this.$route.name.includes('checkout')"
          >רגע, יש לנו מבצע יציאה בשבילך!</h2>
          <h2 class="title25" v-if="!this.$route.name.includes('checkout')">{{computedTitle}}</h2>
          <p v-if="this.popup_subtitle" class="subtitle">{{this.popup_subtitle}}</p>
          <div class="pp_slide_wrap small-arrows" :class="{'slide_2' : products.length == 2 }">
            <div class="arrow_r ease" style="display:none;">
              <a href="javascript:void(0);" @click.prevent="prev">
                <arrow-right />
              </a>
            </div>
            <div class="arrow_l ease" style="display:none;">
              <a href="javascript:void(0);" @click.prevent="next">
                <arrow-left />
              </a>
            </div>
            <div class="pp_slide clearfix" v-if="products">
              <slick
                ref="slick"
                :options="slickOptions"
                v-if="products && slickOptions.nextArrow && slickOptions.prevArrow"
              >
                <Product
                  v-bind:product="product"
                  v-bind:index="index"
                  v-bind:is_popup="true"
                  v-for="(product, index) in (products)"
                  :key="product.id"
                ></Product>
              </slick>
            </div>
          </div>
          <div class="pp_note" v-html="disclaimer_pop"></div>
          <div v-if="is_checkout_promo" class="goto-checkout bt_green ease">
            <a @click="closePop();">&nbsp;{{this.popup_cta}}&nbsp;</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Close from "../../assets/img/close.svg";
import arrowLeft from "../../assets/img/arrow_l.svg";
import arrowRight from "../../assets/img/arrow_r.svg";
import Product from "../Product/Product";
import Slick from "vue-slick";
import { mapState, mapActions } from "vuex";
export default {
  props: [ "products", "title", "popup_title", "popup_subtitle", "popup_cta", "is_checkout_promo", "popup_redirect_to"],
  data() {
    return {
      disclaimer_pop: wpData.globalOptions.sale_banner_text,
      slickOptions: {
        rtl: true,
        dots: false,
        infinite: true,
        arrows: true,
        centerMode: false,
        nextArrow: false,
        prevArrow: false,
        slidesToShow: Object.values(this.products).length < 3 ? (this.products.length == 2 ? 2:1) : 3,
        slidesToScroll: Object.values(this.products).length < 3 ? (this.products.length == 2 ? 2:1) : 3,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 800,
            settings: "unslick"
          }
        ]
      }
    };
  },
  mounted() {
    let r_arrow = $(".arrow_l");
    let l_arrow = $(".arrow_r");
    this.slickOptions.nextArrow = r_arrow;
    this.slickOptions.prevArrow = l_arrow;

    // GA Tag for checkout promo
    if ( this.is_checkout_promo ) {
      if (typeof ga !== 'undefined') {
        ga.getAll()[0].send({
          hitType: 'event',
          eventCategory: 'Cart',
          eventAction: 'Checkout promotion popup',
          eventLabel: 'Popup was show',
          eventValue: 0,
          nonInteraction: true
        });
      }
    }

  },
  computed: {
    ...mapState({ state_products: "products" }),
    computedTitle(){
      if ( this.popup_title ) {
        return this.popup_title;
      } else {
        return 'מבצע מיוחד';
      }
    }
  },
  methods: {
    next() {
      //this.$refs.slick.next();
    },
    prev() {
      //  this.$refs.slick.prev();
    },
    closePop() {
      this.$modal.hide("sales-pop");
      if ( this.is_checkout_promo ) {
        this.$modal.hide("checkout-promo-popup");
        this.$router.push({ name: this.popup_redirect_to });
      }
    },
    getProducts(pr) {
      let arr = [];
      let products = Object.values(this.state_products);

      let products_values = Object.values(pr);
      products_values.map(function(key) {
        let p = products.find(p => p.id == key);
        arr.push(p);
      });
      return arr;
    }
  },

  components: {
    Close,
    Slick,
    arrowLeft,
    arrowRight,
    Product
  }
};
</script>

<style scoped lang="sass">
  
  .subtitle
    text-align: center
    margin: -1.85rem auto 2rem
  
  .is_checkout_promo
  
    .popup_in
      background: rgba(0,0,0,0.7)

    .goto-checkout
      text-align: center
      a
        margin-top: 0
        margin-bottom: 1rem
        padding: 0 1rem
        white-space: nowrap
        display: inline-block
        width: auto
        cursor: pointer

</style>